import type { YmdRoute } from '@yoummday/ymmd-router/dist/types';

export default <Record<string, YmdRoute>>{
	'/extra-fee': {
		as: 'extra-fee',
		module: () => import('.'),
		hasHeader: true,
		hasAsideNavigation: true,
	},
};
